<template>
  <v-container fluid fill-height class="ma-0 pa-0">
    <!-- MESSAGE FOR CLEAR WHO -->
    <v-dialog
      v-model="showMessageClearWho"
      persistent
      max-width="390"
    >
      <message-clear-who
        :vehicles="vehiclesAttached.length"
        @clearVehiclesFromMessage="clearVehiclesFromMessage"
        @closeMessageClearWho="closeMessageClearWho"
      />
    </v-dialog>
    <!-- VEHICLE LIST OTHER AGENCY -->
    <v-dialog
      v-model="showListVehiclesOtherAgency"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card width="500" class="pa-4">
        <h3>VEHÍCULOS QUE CAMBIARON DE GRUPO/AGENCIA</h3>
        <p class="pt-4">
          <v-icon left large>warning</v-icon>
          {{ textOtherAgencyVehicles }}
        </p>
        <v-flex d-inline-flex align-baseline>
          <h4>Vehículos que cambiaron de Grupo/Agencia:</h4>
          <h3 class="ml-2">{{ vehiclesListOtherAgency.length }}</h3>
        </v-flex>
        <!-- LIST -->
        <v-flex
          id="container-who-1"
          class="scroll-section"
          ml-2
        >
          <v-flex
            v-for="(vehicle, index) in vehiclesListOtherAgency"
            :key="index"
            pt-1 px-1
          >
            <!-- <v-list-tile-content> -->
            <v-flex
              :class="[index % 2 ? rowbgalt : rowbg]"
              d-inline-flex
              align-center
            >
              <v-flex
                class="list-who body-2"
                d-flex
                align-center
              >
                {{ 
                  `${vehicle.code !== null ? vehicle.code : ''} | ${vehicle.licensePlate}` 
                }}
              </v-flex>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- DELETE ALL -->
        <h3 class="mt-1">
          {{ textDeleteOtherAgencyVehicles }}
        </h3>
        <v-flex d-flex>
          <v-flex mr-1>
            <v-btn
              block
              outline
              color="error"
              @click="showListVehiclesOtherAgency = false"
            >
              <v-icon left>cancel</v-icon>
              Cancelar
            </v-btn>
          </v-flex>
          <v-flex ml-1>
            <v-btn
              block
              color="error"
              :disabled="optionSelected !== 0 || vehiclesListOtherAgency.length === 0"
              @click="setNewVehiclesAtached"
            >
              <v-icon left>delete_forever</v-icon>
              Eliminar Vehículos
            </v-btn>
          </v-flex>
        </v-flex>
        <!-- CLOSE -->
        <v-flex>
          <v-btn
            color="primary"
            style="top:10px;"
            absolute
            top
            right
            depressed
            small
            fab
            @click="showListVehiclesOtherAgency = false"
          >
            <v-icon>clear</v-icon>
          </v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
    <!-- FULL EDITION DIALOG -->
    <div v-if="showModifyFinal">
      <v-dialog
        :value="showModifyFinal"
        max-width="500"
        persistent
      >
        <v-card width="500">
          <v-flex>
            <modify-mission-final
              :itemSelected="itemSelected"
              :optionSelected="optionSelected"
              :dataToUpdate="dataToUpdate"
              :startDateCurrent="startDateCurrent"
              :startTimeCurrent="startTimeCurrent"
              :futureMission="futureMission"
              @finishAction="finishAction"
              @showMessage="showErrorStartDate = true"
              @close="closeDialog"
            />
          </v-flex>
          <!-- CLOSE -->
          <v-flex>
            <v-btn
              color="primary"
              style="top:10px;"
              absolute
              top
              right
              depressed
              small
              fab
              @click="closeDialog"
            >
              <v-icon>clear</v-icon>
            </v-btn>
          </v-flex>
        </v-card>
      </v-dialog>
    </div>
    <!-- CONTENT -->
    <v-layout column>
      <v-card class="ma-0 pa-0">
        <!-- ERROR MESSAGE WHERE -->
        <v-snackbar
          color="error"
          v-model="showErrorStartDate"
          :timeout="0"
          auto-height
        >
          <v-flex>
            <v-icon left large>warning</v-icon>
            <p>
              No es posible realizar la modificación del cuándo, debe ajustar la información ingresada nuevamente según el caso.
            </p>
          </v-flex>
          <v-btn dark flat @click.native="showErrorStartDate = false">OK</v-btn>
        </v-snackbar>
        <!-- CONTENT IN -->
        <v-toolbar dark color="grey darken-3">
          <v-toolbar-title v-if="optionSelected !==3">
            {{ `EDITANDO: ${optionsToEditMap.get(optionSelected)}`}}
          </v-toolbar-title>
          <v-toolbar-title v-else>
            <v-icon class="mr-2">visibility</v-icon>SOLO LECTURA
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- CLOSE -->
          <v-btn icon dark @click="$emit('cancel')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-layout column>
          <v-flex class="container-full-edition">
            <!-- WHAT & WHERE -->
            <v-toolbar dense flat>
              <v-toolbar-title>Qué y Dónde</v-toolbar-title>
            </v-toolbar> 
            <v-flex d-flex py-3>
              <v-flex style="max-width: 550px;min-width: 550px;" px-5>
                <h2>{{ itemSelected.name }}</h2>
              </v-flex>
              <v-divider vertical></v-divider>
              <v-flex px-3>
                <v-flex v-if="selections.length === 0">
                  <h3>Seleccionar una misión</h3>
                  <v-flex py-5 class="text-xs-center">
                    <v-avatar
                      size="100px"
                      color="grey darken-4">
                      <v-icon color="grey darken-3" size="80px">flag</v-icon>
                    </v-avatar>
                  </v-flex>
                </v-flex>
                <v-flex v-else>
                  <h3>{{ selections.length === 1 ? 'Misión Seleccionada' : 'Misiones Seleccionadas' }}</h3>
                  <v-scroll-x-transition
                    group
                    hide-on-leave
                  >
                    <v-flex
                      v-for="(selection, i) in selections"
                      :key="i"
                      py-1
                    >
                      <v-flex pb-2>
                        <v-chip
                          color="grey lighten-4"
                          dark
                          small
                        >
                          <v-icon left small color="grey darken-4">mdi-check-circle</v-icon>
                          <v-flex d-flex>
                            <v-flex class="name-selection">
                              <b>{{ `${selection.name} -` }}</b>
                            </v-flex>
                            <v-flex class="description-selection">
                              {{ `| ${selection.description}` }}
                            </v-flex>
                          </v-flex>
                        </v-chip>
                      </v-flex>
                      <v-flex v-if="selection.where.length > 1" px-3 py-1>
                        <v-select
                          v-model="whereSelected"
                          :items="whereData(selection.where)"
                          item-text="text"
                          item-value="value"
                          label="Dónde"
                          multiple
                          box
                          clearable
                          :disabled="optionSelected !== 1"
                          @change="changeAction"
                        ></v-select>
                      </v-flex>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-scroll-x-transition>
                  <!-- ANALYZE PARKING CHECKBOX -->
                  <v-checkbox
                    v-if="adminRole === 500"
                    v-model="itemSelected.analyzeParking"
                    label="Seguimiento de Estacionarias Prolongadas"
                    readonly
                  ></v-checkbox>
                </v-flex>
              </v-flex>
            </v-flex>
            <!-- WHEN & WHO -->
            <v-flex v-if="selections.length > 0" d-flex mb-3>
              <!-- WHEN -->
              <v-flex style="max-width:550px;min-width:550px;">
                <v-toolbar dense flat>
                  <v-toolbar-title>Cuándo</v-toolbar-title>
                </v-toolbar>
                <!-- ------------------------- -->
                <!-- CUSTOM -->
                <!-- ------------------------- -->
                <!-- DATE SELECTION -->
                <v-flex px-3 style='max-height:"100";'>
                  <v-flex d-inline-flex align-center>
                    <v-flex style="max-width:20px;">
                      <v-icon color="grey">event</v-icon>
                    </v-flex>
                    <v-flex>
                      <v-subheader style="font-weight: bolder">Fecha</v-subheader>
                    </v-flex>
                  </v-flex>
                  <!-- INPUT TEXT -->
                  <v-flex d-flex >
                    <v-flex xs6 pr-2>
                      <v-menu
                        ref="startDate"
                        v-model="startDateMenu"
                        lazy
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        min-width="290px"
                        :return-value.sync="startDate"
                        :disabled="optionSelected !== 2 || !futureMission"
                      >
                        <v-text-field
                          slot="activator"
                          label="Fecha de inicio"
                          v-model="startDate"
                          prepend-inner-icon="event"
                          readonly
                          box
                          :disabled="optionSelected !== 2 || !futureMission"
                        ></v-text-field>
                        <v-date-picker
                          v-model="startDate"
                          no-title
                          scrollable
                          locale="es"
                          :allowed-dates="allowedStartDates"
                          @change="startDateChanges"
                        >
                          <v-spacer></v-spacer>
                          <v-btn color="error" @click="startDateMenu = false">Cancelar</v-btn>
                          <v-btn color="primary" @click="$refs.startDate.save(startDate)">Elegir</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs6 pl-2>
                      <v-menu
                        ref="endDate"
                        v-model="endDateMenu"
                        lazy
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        max-width="290px"
                        min-width="290px"
                        :return-value.sync="endDate"
                        :disabled="optionSelected !== 2 ||
                            !(activeMission || futureMission)"
                      >
                        <v-text-field
                          slot="activator"
                          label="Fecha de fin"
                          v-model="endDate"
                          prepend-inner-icon="event"
                          readonly
                          box
                          :disabled="optionSelected !== 2 ||
                            !(activeMission || futureMission)"
                        />
                        <!-- @change="endDateChanges" -->
                        <v-date-picker 
                          v-model="endDate" 
                          no-title 
                          scrollable 
                          locale="es"
                          :allowed-dates="allowedEndDates"
                          @input="changeAction"
                        >
                          <v-spacer></v-spacer>
                          <v-btn color="error" @click="endDateMenu = false">Cancelar</v-btn>
                          <v-btn color="primary" @click="changeEndDate">Elegir</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-flex>
                </v-flex>
                <!-- TIME SELECTION -->
                <v-flex v-if="endDate" style='max-height:"100";' px-3>
                  <v-flex d-inline-flex align-center>
                    <v-flex style="max-width: 20px;">
                      <v-icon color="grey">access_time</v-icon>
                    </v-flex>
                    <v-flex>
                      <v-subheader style="font-weight: bolder">Tiempo</v-subheader>
                    </v-flex>
                  </v-flex>
                  <v-flex d-flex>
                    <!-- START TIME -->
                    <v-flex xs6 pr-2>
                      <!-- :nudge-right="40" -->
                      <v-menu
                        ref="startTime"
                        v-model="startTimeMenu"
                        lazy
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :return-value.sync="startTime"
                        :disabled="optionSelected !== 2 || !futureMission"
                      >
                        <v-text-field
                          slot="activator"
                          label="Hora de inicio"
                          v-model="startTime"
                          prepend-inner-icon="access_time"
                          readonly
                          box
                          :disabled="optionSelected !== 2 || !futureMission"
                        ></v-text-field>
                        <v-time-picker
                          v-model="startTime"
                          ref="startTimePicker"
                          format="24hr"
                          scrollable
                          landscape
                          :allowed-hours="allowedStartHour"
                          :allowed-minutes="allowedStartMinute"
                          @input="changeStartTime"
                        >
                          <v-spacer></v-spacer>
                          <v-btn color="error" @click="startTimeMenu = false">Cancelar</v-btn>
                          <v-btn color="primary" @click="acceptStartTime">Aceptar</v-btn>
                        </v-time-picker>
                      </v-menu>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <!-- END TIME -->
                    <v-flex v-if="showEndTime" xs6 pl-2>
                      <v-menu
                        ref="endTime"
                        v-model="endTimeMenu"
                        lazy
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :return-value.sync="endTime"
                        :disabled="
                          optionSelected !== 2 || !(activeMission || futureMission)
                        "
                      >
                        <v-text-field
                          slot="activator"
                          label="Hora de fin"
                          v-model="endTime"
                          prepend-inner-icon="access_time"
                          readonly
                          box
                          :disabled="
                            optionSelected !== 2 || !(activeMission || futureMission)
                          "
                        />
                        <v-time-picker 
                          v-model="endTime"
                          ref="endTimePicker"
                          format="24hr"
                          scrollable
                          landscape
                          :allowed-hours="allowedEndHour"
                          :allowed-minutes="allowedEndMinute"
                          @click:hour="endTimeHourSelected"
                          @input="changeAction"
                        >
                          <v-spacer></v-spacer>
                          <v-btn color="error" @click="endTimeMenu = false">Cancelar</v-btn>
                          <v-btn color="primary" @click="$refs.endTime.save(endTime)">Aceptar</v-btn>
                        </v-time-picker>
                      </v-menu>
                    </v-flex>
                  </v-flex>
                </v-flex>
              </v-flex>
              <!-- WHO -->
              <v-divider vertical></v-divider>
              <v-flex>
                <v-flex>
                  <v-toolbar dense flat>
                    <v-toolbar-title>Quién</v-toolbar-title>
                  </v-toolbar>
                </v-flex>
                <v-flex>
                  <v-card-text style="min-height: 200px">
                    <v-layout>
                      <!-- SEARCH VEHICLE -->
                      <v-flex style="max-width:390px;min-width:390px;" pr-3>
                        <v-text-field
                          ref="search"
                          v-model="searchVehicleValue"
                          flat
                          box
                          prepend-inner-icon="search"
                          color="white"
                          label="Código/Sigla ó Placa"
                          :disabled="optionSelected !== 0"
                          @keyup.enter="searchVehicle"
                        >
                        </v-text-field>
                        <!-- SEARCH RESULT -->
                        <v-scroll-x-transition>
                          <v-flex
                            v-if="searchAction"
                            class="container-search-result"
                            mb-2
                          >
                            <v-flex d-flex align-center>
                              <v-flex class="h7" pl-4>
                                Resultado
                              </v-flex>
                              <v-flex class="text-xs-right" pr-3>
                                <v-btn
                                  color="white"
                                  flat
                                  small
                                  fab
                                  @click="clearSearch">
                                  <v-icon>close</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-flex>
                            <!-- <transition name="fade"> -->
                            <v-flex v-if="searchVehicleResult.length > 0">
                              <!-- ALREADY ADDED -->
                              <v-flex v-if="vehicleAlreadyAdded" class="h7" pl-4 pb-3>
                                El vehículo ya fue agregado a la lista.
                              </v-flex>
                              <v-flex
                                v-else
                                v-for="(vehicle, index) in searchVehicleResult"
                                :key="index"
                                class="text-xs-center info-vehicle-r pointer-1"
                                d-flex
                                mx-4
                                align-center
                                @click="addWho(vehicle)"
                              >
                                <v-flex pr-2>
                                  {{ vehicle.code }}
                                </v-flex>
                                <v-flex style="width: 80px;min-width: 60px;" pr-4>
                                  <v-flex class="plate-border">
                                    {{ vehicle.licensePlate }}
                                  </v-flex>
                                </v-flex>
                                <v-flex style="max-width: 30px;min-width: 30px;" pr-1>
                                  <v-icon>add</v-icon>
                                </v-flex>
                              </v-flex>
                              <br>
                            </v-flex>
                            <!-- NOT FOUND -->
                            <v-flex v-else>
                              <v-flex class="h7" pl-4 pb-3>
                                No se encontró vehículo válido para la misión seleccionada!
                              </v-flex>
                            </v-flex>
                            <!-- </transition> -->
                          </v-flex>
                        </v-scroll-x-transition>
                      </v-flex>
                      <v-divider vertical></v-divider>
                      <!-- VEHICLE LIST -->
                      <v-flex>
                        <v-card
                          class="CreateMissionView__card"
                          elevation="0"
                          width="390"
                          height="340"
                        >
                          <v-card-title class="subheader">
                            <v-flex d-inline-flex align-baseline>
                              <h4 style="max-width:170px;">Vehículos seleccionados:</h4>
                              <h3>{{ vehiclesAttached.length }}</h3>
                            </v-flex>
                          </v-card-title>
                          <!-- LIST -->
                          <v-flex
                            id="container-who-1"
                            class="scroll-section"
                            ml-2
                          >
                            <v-flex
                              v-for="(vehicle, index) in vehiclesAttached"
                              :key="index"
                              pt-1 px-1
                            >
                              <!-- <v-list-tile-content> -->
                              <v-flex
                                :class="[index % 2 ? rowbgalt : rowbg]"
                                d-inline-flex
                                align-center
                              >
                                <v-flex
                                  class="list-who body-2"
                                  d-flex
                                  align-center
                                >
                                  {{
                                    `${vehicle.code !== null ? vehicle.code : ''} | ${vehicle.licensePlate}`
                                  }}
                                </v-flex>
                                <v-flex>
                                  <v-btn
                                    flat
                                    small
                                    icon
                                    :disabled="optionSelected !== 0"
                                    @click="deleteFromDraggableList(index,vehiclesAttached)"
                                  >
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-flex>
                            </v-flex>
                          </v-flex>
                          <!-- CLEAR LIST -->
                          <v-flex
                            v-if="vehiclesAttached.length > 0"
                            xs12
                            class="text-xs-left"
                            pl-2
                          >
                            <v-btn
                              small
                              block
                              color="error"
                              :disabled="optionSelected !== 0"
                              @click="clearVehiclesAttached"
                            >
                              <v-icon left>clear</v-icon>
                              Limpiar
                            </v-btn>
                          </v-flex>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-flex>
              </v-flex>
            </v-flex>
            <v-divider
              v-if="selections.length > 0 && optionSelected !== 3"
              class="mx-3"
            ></v-divider>
            <v-flex
              v-if="selections.length > 0 && optionSelected !== 3"
              class="text-xs-center"
              my-3
            >
              <v-btn
                color="primary"
                dark
                style="width: 290px;"
                :disabled="checkContinue"
                @click="continueModify"
              >
                <v-icon left>navigate_next</v-icon>
                Continuar
              </v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { missionsMixin } from '../../../mixins/missionsMixin'
import { agenciesMixin } from '../../../mixins/agenciesMixin'
import { missionInProgressMixin } from '../../../mixins/missionInProgressMixin'

import ModifyMissionFinal from './ModifyMissionFinal'
import MessageClearWho from '../MessageClearWho'

import _ from 'lodash'

const optionsToEditMap = new Map([
  [0, 'Quién (vehículos)'],
  [1, 'Qué y Dónde (zonas)'],
  [2, 'Cuándo (fechas y horas)']
])

export default {
  name: 'modify-mission-full-edition',
  mixins: [
    agenciesMixin,
    missionsMixin,
    missionInProgressMixin
  ],
  components: {
    ModifyMissionFinal,
    MessageClearWho
  },
  props: ['itemSelected', 'optionSelected'],
  data() {
    return {
      endHourSelected: null,
      showErrorStartDate: false,
      futureMission: false,
      activeMission: false,
      // currentDateTime: '',
      dataToUpdate: null,
      showModifyFinal: false,
      rowbgalt: 'bg-row-alt',
      rowbg: 'bg-row',
      searchAction: false,
      startTime: null,
      startTimeCurrent: null,
      /**
       * Hora a la que termina la misión
       * @description Cuando?
       * @type {string}
       */
      endTime: null,
      endTimeCurrent: null,
      /**
       * Fecha la que inicia la misión
       * @description Cuando?
       * @type {string}
       */
      startDate: null,
      startDateCurrent: null,
      /**
       * Fecha la que termina la misión
       * @description Cuando?
       * @type {string}
       */
      endDate: null,
      endDateCurrent: null,
      /**
       * Controla la visibilidad del selector de tiempo
       * @type {boolean}
       */
      startTimeMenu: false,
      endTimeMenu: false,
      /**
       * Controla la visibilidad del selector de fechas
       * @type {boolean}
       */
      startDateMenu: false,
      endDateMenu: false,
      vehiclesAttached: [],
      vehiclesAttachedCurrent: [],
      searchVehicleValue: null,
      vehicleAlreadyAdded: false,
      messageToShow: {},
      showDialogMessage: false,
      selectionsAgencies: [],
      showEndTime: false,
      startDateTurn: '',
      endDateTurn: '',
      startDateTurnMenu: false,
      endDateTurnMenu: false,
      turnTypesSelection: '',
      turnTypes: [
        {text: 'Turno 2', value: ['06:00', '14:00']},
        {text: 'Turno 3', value: ['14:00', '22:00']},
        {text: 'Turno 4-1', value: ['22:00', '06:00']}
      ],
      baseMissionId: null,
      description: null,
      name: null,
      whereSelected: [],
      whereSelectedCurrent: [],
      selections: [],
      optionsToEditMap,
      vehiclesListOtherAgency: [],
      showListVehiclesOtherAgency: false,
      newVehiclesAttached: [],
      showMessageClearWho: false
    }
  },
  watch: {
    currentDateTime(newValue) {
      // console.log('WATCH currentDateTime', newValue)
      // console.log('Item Selected start', this.itemSelected.startDate)
      // console.log('Item Selected end', this.itemSelected.endDate)

      this.activeMission = this.$moment(newValue).isBefore(this.itemSelected.endDate) && this.$moment(newValue).isAfter(this.itemSelected.startDate)

      this.futureMission = this.$moment(newValue).isBefore(this.itemSelected.startDate)

      // console.log('ACTIVE', this.activeMission)
      // console.log('FUTURE', this.futureMission)
    }
  },
  computed: {
    ...mapGetters([
      'currentDateTime',
      'agenciesTree',
      'missionsServicesRaw',
      'missionsTemplates',
      'vehiclesInAMission'
      // 'showMessageClearWho'
    ]),
    ...mapGetters({
      fullZoneMaps: 'filters/fullZoneMaps',
      adminRole: 'auth/adminRole'
    }),
    checkContinue() {
      let result = true
      switch (this.optionSelected) {
        case 0: // WHO
          const idVehicles = []
          this.vehiclesAttached.forEach(element => {
            idVehicles.push(element.id)
          })
          // console.log('idVehicles', idVehicles)
          const sameWho = _.isEqual(_.sortBy(this.vehiclesAttachedCurrent), _.sortBy(idVehicles))
          // console.log('EQUAL WHO', sameWho)
          result = !(this.vehiclesAttached.length > 0) || sameWho
          // console.log(this.vehiclesAttached)
          // console.log(this.vehiclesAttachedCurrent)
          // console.log('checkContinue WHO 1', !(this.vehiclesAttached.length > 0))
          // console.log('checkContinue WHO 2', !(this.vehiclesAttached !== this.vehiclesAttachedCurrent))
          // console.log('checkContinue WHO', result)
          break
        case 1: // WHERE
          const sameWhere = _.isEqual(_.sortBy(this.whereSelectedCurrent), _.sortBy(this.whereSelected))
          result = !(this.whereSelected.length > 0) || sameWhere
          // console.log('EQUAL WHERE', sameWhere)
          // console.log('checkContinue WHERE 1', !(this.whereSelected.length > 0))
          // console.log('checkContinue WHERE 2', !(this.whereSelected !== this.whereSelectedCurrent))
          // console.log('checkContinue WHERE', result)
          break
        case 2: // WHEN
          const sameStartTime = this.startTimeCurrent === this.startTime
          const sameEndTime = this.endTimeCurrent === this.endTime
          const sameStartDate = this.startDateCurrent === this.startDate
          const sameEndDate = this.endDateCurrent === this.endDate
          const sameDateTime = sameStartTime && sameEndTime && sameStartDate && sameEndDate
          // console.log('EQUAL WHEN', sameEndDate)
          result = !(this.startTime && this.startDate && this.endTime && this.endDate) || sameDateTime
          // console.log('checkContinue WHEN', result)
          break
        default:
          break
      }
      return result
    },
    textOtherAgencyVehicles() {
      let result = ''
      if (this.vehiclesListOtherAgency.length > 1) {
        result = 'Los siguientes vehículos fueron asignados a un nuevo grupo/agencia. Para continuar con las modificaciones deben ser eliminados de la misión.'
      } else {
        result = 'El siguiente vehículo fue asignado a un nuevo grupo/agencia. Para continuar con las modificaciones debe ser eliminado de la misión.'
      }
      return result
    },
    textDeleteOtherAgencyVehicles() {
      let result = ''
      if (this.vehiclesListOtherAgency.length > 1) {
        result = '¿Está seguro de eliminarlos de la misión?'
      } else {
        result = '¿Está seguro de eliminarlo de la misión?'
      }
      return result
    }
  },
  methods: {
    ...mapActions([
      'getCurrentDateTime',
      'searchVehicleAction',
      'clearVehiclesInAMission'
    ]),
    changeEndDate() {
      this.$refs.endDate.save(this.endDate)
      // console.log('changeEndDate', this.startDate, this.endDate)
      if (this.startDate === this.endDate) {
        this.endTime = this.$moment(`${this.startDate} ${this.startTime}`).add(1, 'm').format('HH:mm')
        if (this.activeMission) {
          const today = this.$moment.now()
          this.endTime = this.$moment(today).format('HH:mm')
        }
      }
    },
    endTimeHourSelected(value) {
      this.endHourSelected = value
      // console.log('endTimeHourSelected', this.endHourSelected)
    },
    allowedEndHour(value) {
      let result = true
      if (this.endDate === this.startDate) {
        const startTime = this.startTime.split(':')
        result = value >= Number(startTime[0])
        if (this.activeMission) {
          const today = this.$moment.now()
          const currentHour = this.$moment(today).format('HH')
          result = value >= Number(currentHour)
        }
      }
      return result
    },
    allowedEndMinute(value) {
      let result = true
      // console.log('allowedEndMinute END', this.$refs.endTimePicker.value, this.endHourSelected)
      const tempStartTime = this.startTime.split(':')
      if (this.endDate === this.startDate) {
        const today = this.$moment.now()
        const currentHour = this.$moment(today).format('HH')
        const currentMinute = this.$moment(today).format('mm')
        if (this.endHourSelected === Number(tempStartTime[0])) result = value > Number(tempStartTime[1])
        if (this.activeMission && this.endHourSelected === Number(currentHour)) {
          result = value > Number(currentMinute)
        }
      }
      return result
    },
    allowedStartHour(value) {
      let result = true
      let today = this.$moment.now()
      const currentDate = this.$moment(today).format('YYYY-MM-DD')
      if (this.startDate === currentDate) {
        const currentHour = this.$moment(today).format('HH')
        result = !(value < Number(currentHour))
      }
      return result
    },
    allowedStartMinute(value) {
      let result = true
      let today = this.$moment.now()
      const currentDate = this.$moment(today).format('YYYY-MM-DD')
      const currentHour = this.$moment(today).format('HH')
      if (this.startDate === currentDate) {
        const tempTime = this.$refs.startTimePicker.value.split(':')
        if (Number(currentHour) === Number(tempTime[0])) {
          const currentMinute = this.$moment(today).format('mm')
          result = !(value < Number(currentMinute))
        }
      }
      return result
    },
    allowedStartDates(date) {
      let today = this.$moment.now()
      today = this.$moment(today).format('YYYY-MM-DD')
      let datesResult = this.$moment(date).isSameOrAfter(today)
      return datesResult
    },
    finishAction() {
      this.dataToUpdate = null
      this.showModifyFinal = false
      this.clearVehiclesInAMission()
      this.$emit('finishAction')
    },
    validateWhenBeforeContinue() {
      let result = false
      const nowDateTime = this.$moment.now()
      const currentDateTime = this.$moment(nowDateTime).format('YYYY-MM-DD HH:mm')
      const currentMissionStartDateTime = `${this.startDateCurrent} ${this.startTimeCurrent}`
      // Validate if the mission has started
      if (this.$moment(currentDateTime).isAfter(currentMissionStartDateTime)) return result

      // Validate if the modifiyed Start Date and Time is X minutes before now
      const pastDateTime = this.$moment(nowDateTime).subtract(15, 'minute')
      const modifyedStartDateTime = `${this.startDate} ${this.startTime}`
      result = !this.$moment(modifyedStartDateTime).isBefore(pastDateTime)
      // console.log('isBefore', result)
      return result
    },
    continueModify() {
      let canModify = true
      switch (this.optionSelected) {
        case 0: // WHO
          this.changeAction()
          // Verify if the current vehicles are valid for the mission
          this.checkVehicles()
          if (this.vehiclesListOtherAgency.length === 0) {
            this.dataToUpdate = this.vehiclesAttached.map(vehicle => {
              return vehicle.id
            })
          } else {
            canModify = false
            this.showListVehiclesOtherAgency = true
          }
          break
        case 1: // WHERE
          this.changeAction()
          // WHERE: checks the special cases of San Cristóbal & San Javier polygons
          const whereSelectedChecked = []
          this.whereSelected.forEach(element => {
            const isArrayEl = Array.isArray(element)
            if (isArrayEl) {
              element.forEach(elementIn => {
                whereSelectedChecked.push(elementIn)
              })
            } else whereSelectedChecked.push(element)
            console.log('whereSelectedChecked', whereSelectedChecked)
          })
          this.dataToUpdate = whereSelectedChecked
          break
        case 2: // WHEN
          this.changeAction()
          if (this.futureMission) {
            if (!this.validateWhenBeforeContinue()) {
              canModify = false
              this.showErrorStartDate = true
              break
            }
          }
          this.dataToUpdate = {
            time: {
              start: this.startTime,
              end: this.endTime
            },
            dates: {
              start: this.startDate,
              end: this.endDate
            }
          }
          break
        default:
          break
      }
      this.showModifyFinal = canModify
    },
    clearSearch() {
      this.changeAction()
      this.searchAction = false
      this.searchVehicleResult = []
    },
    addWho(vehicle) {
      // console.log('ADD WHO: ', vehicle)
      const index = this.vehiclesAttached.findIndex(item => item.id === vehicle.id)
      if (index === -1) this.vehiclesAttached.push(vehicle)
      this.clearSearch()
    },
    /**
     * Metodo que solo permite verificar que  un item de la lista no este repetido cuando se agrega uno nuevo
     * @param event
     * @param list
     */
    handleChangeInDraggableList(event, list = []) {
      if ('added' in event) {
        let {element: newElement, newIndex} = event.added
        let queryElement = list.filter(listItem => listItem.id === newElement.id)
        if (queryElement.length > 1) {
          list.splice(newIndex, 1)
        }
      }
    },
    /**
     * Metodo que permite borrar un item de una lista arrastrable
     * @param index
     * @param list
     */
    deleteFromDraggableList(index, list) {
      this.changeAction()
      // list.splice(index, 1)
      this.vehiclesAttached.splice(index, 1)
    },
    /**
     * Metodo que permite agregar un objecto a una lista arrastrable
     * @param item
     * @param list
     */
    addToDraggableList(item, list) {
      let isItemInList = list.filter(listItem => item.id === listItem.id)
      if (isItemInList.length === 0) {
        list.push(item)
      }
    },
    acceptStartTime() {
      this.$refs.startTime.save(this.startTime)
      this.showEndTime = true
      if (this.startDate === this.endDate) {
        // console.log('acceptStartTime', this.startTime)
        this.endDate = this.$moment(`${this.startDate} ${this.startTime}`).add(1, 'm').format('YYYY-MM-DD')
        this.endTime = this.$moment(`${this.startDate} ${this.startTime}`).add(1, 'm').format('HH:mm')
      }
    },
    searchVehicle() {
      this.changeAction()
      this.searchVehicleResult = []

      this.vehicleAlreadyAdded = false

      if (this.searchVehicleValue !== null) {
        this.searchAction = false
        this.searchVehicleAction(this.searchVehicleValue)
          .then(result => {
            let inGroup = true
            let restriction = -1
            if (result.length > 0) {
              const agencyIdResult = result[0].agencyId
              // console.log('agencyIdResult: ', agencyIdResult)
              this.parentIdNext = agencyIdResult
              this.selectionsAgencies = []

              // console.log('templateSelectedIn', this.templateSelectedIn)
              this.active[0] = this.templateSelectedIn.agencyId
              // console.log(this.active)
              if (this.active[0] !== null) {
                this.recursiveSearch(this.agenciesTree)
                // console.log('AGENCY SELECTED: ', this.agencySelectedIn, this.active)
              }

              this.agencyIds = []
              this.recursiveSearchIn(this.agencySelectedIn)
              this.agencyIds.push(this.templateSelectedIn.agencyId)
              // console.log('AGENCIES ID IN: ', this.agencyIds)

              inGroup = this.agencyIds.includes(agencyIdResult)
              // console.log('MATCH GROUP: ', inGroup)

              if (this.templateSelectedIn.disabledAgencies !== null) {
                while (this.parentIdNext !== null) {
                  // console.log('WHILE X: ', this.parentIdNext)
                  this.recursiveSearchUp(this.agenciesTree, this.parentIdNext)
                  this.matchUp = false
                }
                this.selectionsAgencies = this.templatesUp
                // console.log('AGENCIES SELECTIONS: ', this.selectionsAgencies)
                this.templatesUp = []

                restriction = this.selectionsAgencies.findIndex(item => item.id === this.templateSelectedIn.disabledAgencies)
                // console.log('RESTRICTION: ', restriction)
              }
              if (inGroup && restriction === -1) {
                this.searchVehicleResult = result
                const index = this.vehiclesAttached.findIndex(item => item.id === this.searchVehicleResult[0].id)
                // console.log('vehicleAlreadyAdded - index', index)
                if (index !== -1) this.vehicleAlreadyAdded = true
              }
            } else this.searchVehicleResult = result
            // this.searchVehicleValue = null
            this.searchAction = true
          })
      }
    },
    changeStartTime() {
      this.changeAction()
      // this.endTime = null
    },
    allowedEndDates(date) {
      let result = true
      if (this.startDate) {
        const startDateSelected = this.$moment(this.startDate).format('YYYY-MM-DD')
        const startTimeSelected = this.$moment(`${this.startDate} ${this.startTime}`).format('HH:mm')
        // console.log('allowedEndDates', startTimeSelected)
        if (startTimeSelected === '23:59') result = this.$moment(date).isAfter(startDateSelected)
        else result = this.$moment(date).isSameOrAfter(startDateSelected)
      }
      return result
    },
    startDateChanges() {
      this.changeAction()
      // this.endDate = this.startDate
      let today = this.$moment.now()
      const currentDate = this.$moment(today).format('YYYY-MM-DD')
      if (this.startDate === currentDate) {
        const currentHour = this.$moment(today).format('HH:mm')
        this.startTime = currentHour
      }
      if (this.startDate === this.endDate) {
        // console.log('acceptStartTime', this.startTime)
        this.endDate = this.$moment(`${this.startDate} ${this.startTime}`).add(1, 'm').format('YYYY-MM-DD')
        this.endTime = this.$moment(`${this.startDate} ${this.startTime}`).add(1, 'm').format('HH:mm')
      }
    },
    clearWhenData() {
      this.startDate = null
      this.endDate = null
      this.startTime = null
      this.endTime = null
      this.startDateTurn = null
      this.endDateTurn = null
    },
    processTime() {
      switch (this.whenTypeSelection) {
        case 'custom':
          return {
            start: this.startTime,
            end: this.endTime
          }
        case 'turn':
          return {
            start: this.turnTypesSelection[0],
            end: this.turnTypesSelection[1]
          }
        default:
          return {}
      }
    },
    whereData(where) {
      // console.log('WHERE', where)
      const items = []
      where.forEach(element => {
        const obj = {
          text: this.fullZoneMaps.get(element),
          value: element
        }
        items.push(obj)
      })
      // console.log('ITEMS WHERE: ', items)
      const whereSort = items.sort(function(a, b) {
        var textA = a.text
        var textB = b.text
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
      })

      let counterSC = 0
      let counterSJ = 0
      const whereSortChecked = []
      for (let index = 0; index < whereSort.length; index++) {
        const element = whereSort[index]
        if (element.text === 'San Cristóbal A' || element.text === 'San Cristóbal B') {
          if (counterSC === 0) {
            whereSortChecked.push({
              text: 'San Cristóbal',
              value: [element.value]
            })
          } else {
            const indexIn = whereSortChecked.findIndex(item => item.text === 'San Cristóbal')
            if (indexIn !== -1) whereSortChecked[indexIn].value.push(element.value)
          }
          counterSC++
        } else if (element.text === 'San Javier A' || element.text === 'San Javier B') {
          if (counterSJ === 0) {
            whereSortChecked.push({
              text: 'San Javier',
              value: [element.value]
            })
          } else {
            const indexIn = whereSortChecked.findIndex(item => item.text === 'San Javier')
            if (indexIn !== -1) whereSortChecked[indexIn].value.push(element.value)
          }
          counterSJ++
        } else whereSortChecked.push(element)
      }

      return whereSortChecked
    },
    clearVehiclesAttached() {
      this.changeAction()
      this.showMessageClearWho = true
    },
    closeDialog() {
      this.showModifyFinal = false
      this.clearVehiclesInAMission()
    },
    checkVehicles() {
      this.newVehiclesAttached = []
      this.vehiclesListOtherAgency = []
      for (let index = 0; index < this.vehiclesAttached.length; index++) {
        const element = this.vehiclesAttached[index]
        // console.log(`VEHICLE ${index}: ${element}`)

        let inGroup = true
        let restriction = -1
        const agencyIdVehicle = element.agencyId

        this.parentIdNext = agencyIdVehicle
        this.selectionsAgencies = []
        this.active[0] = this.templateSelectedIn.agencyId
        // console.log(this.active)
        if (this.active[0] !== null) {
          this.recursiveSearch(this.agenciesTree)
          // console.log('AGENCY SELECTED: ', this.agencySelectedIn, this.active)
        }
        this.agencyIds = []
        this.recursiveSearchIn(this.agencySelectedIn)
        this.agencyIds.push(this.templateSelectedIn.agencyId)

        inGroup = this.agencyIds.includes(agencyIdVehicle)

        if (this.templateSelectedIn.disabledAgencies !== null) {
          // console.log('IF disabledAgencies')
          while (this.parentIdNext !== null) {
            // console.log('WHILE X: ', this.parentIdNext)
            this.recursiveSearchUp(this.agenciesTree, this.parentIdNext)
            this.matchUp = false
          }
          this.selectionsAgencies = this.templatesUp
          // console.log('AGENCIES SELECTIONS: ', this.selectionsAgencies)
          this.templatesUp = []

          restriction = this.selectionsAgencies.findIndex(item => item.id === this.templateSelectedIn.disabledAgencies)
          // console.log('RESTRICTION: ', restriction)
        }

        // console.log('inGroup', inGroup)
        // console.log('restriction', restriction)

        if (inGroup && restriction === -1) {
          // console.log('VEHICLE IN MISSION OK', element)
          this.newVehiclesAttached.push(element)
        } else {
          // console.log('VEHICLE NOT IN MISSION', element)
          this.vehiclesListOtherAgency.push(element)
        }
      }
      // console.log('newVehiclesAttached', this.newVehiclesAttached)

      // this.vehiclesAttached = newVehiclesAttached

      // console.log('vehiclesListOtherAgency', this.vehiclesListOtherAgency)
      // console.log('vehiclesAttached', this.vehiclesAttached)
    },
    deleteVehiclesOtherAgency(index) {
      this.vehiclesListOtherAgency.splice(index, 1)
    },
    setNewVehiclesAtached() {
      this.vehiclesListOtherAgency = []
      this.vehiclesAttached = this.newVehiclesAttached
      this.newVehiclesAttached = []
      this.showListVehiclesOtherAgency = false
      if (this.vehiclesAttached.length > 0) this.continueModify()
    },
    clearVehiclesFromMessage() {
      this.changeAction()
      this.vehiclesAttached = []
    },
    closeMessageClearWho() {
      this.showMessageClearWho = false
    }
  },
  created() {
    // this.currentDateTime = this.$moment().format('YYYY-MM-DD HH:mm')
    // console.log('CURRENT DATE TIME', this.currentDateTime)
    // console.log('CREATED', this.itemSelected)
    // this.activeM = [this.itemSelected.missionID]
    this.activeM = [this.itemSelected.baseMissionId]
    this.selections = []
    this.recursiveSearchM(this.missionsTemplates)
    this.templatesIds = []
    this.templatesIds.push(this.templateSelectedIn.id)

    this.name = this.templateSelectedIn.name
    this.description = this.templateSelectedIn.description
    this.baseMissionId = this.templateSelectedIn.id
    const mission = {
      baseMissionId: this.baseMissionId,
      name: this.name,
      description: this.description,
      where: this.templateSelectedIn.where
    }
    this.selections.push(mission)

    this.match = false

    this.parentIdNext = this.templateSelectedIn.parentId

    if (this.templateSelectedIn.parentId !== null) {
      while (this.parentIdNext !== null) {
        // console.log('WHILE: ', this.parentIdNext)
        this.recursiveSearchUp(this.missionsTemplates, this.parentIdNext)
        this.matchUp = false
      }
    }

    // console.log('SELECTIONS 0: ', this.selections)
    // console.log('Templates Up: ', this.templatesUp)

    const templatesUpLight = []

    this.templatesUp.forEach(element => {
      // console.log('ELEMENT:', element)
      const tempObj = {}
      tempObj.name = element.name
      tempObj.description = element.description
      tempObj.where = element.where
      // console.log('TEMP OBJ:', tempObj)
      templatesUpLight.push(tempObj)
    })
    // console.log('Templates Up Light: ', templatesUpLight)

    // const fullSelection = this.selections.concat(this.templatesUp)
    const fullSelection = this.selections.concat(templatesUpLight)
    // console.log('FULL SELECTION: ', fullSelection)
    this.selections = fullSelection.filter(item => item.where !== null)
    // console.log('SELECTIONS 1: ', this.selections)

    this.templateUpIn = null
    this.templatesUp = []
    this.matchUp = false

    // WHERE DATA INIT
    // Checking the special case of San Cristóbal and San Javier
    // polygons
    this.whereSelected = [...this.itemSelected.whereSelected]
    let indexSC = null
    let indexSJ = null
    const indexes = []
    const whereSelectedSpecial = []
    for (let index = 0; index < this.whereSelected.length; index++) {
      const element = this.whereSelected[index]
      if (element === 33647 || element === 34665) { // San Cristóbal
        if (indexSC === null) {
          const newIndexIn = whereSelectedSpecial.push([element])
          indexSC = newIndexIn - 1
        } else {
          whereSelectedSpecial[indexSC] = [...whereSelectedSpecial[indexSC], element]
        }
        indexes.push(index)
      } else if (element === 33643 || element === 34664) { // San Javier
        if (indexSJ === null) {
          const newIndexIn = whereSelectedSpecial.push([element])
          indexSJ = newIndexIn - 1
        } else {
          whereSelectedSpecial[indexSJ] = [...whereSelectedSpecial[indexSJ], element]
        }
        indexes.push(index)
      }
    }
    for (let index = indexes.length - 1; index >= 0; index--) {
      this.whereSelected.splice(indexes[index], 1)
    }
    // Set the selected polygons of the mission to the state
    // that is related with the v-model of the WHERE
    this.whereSelected = [...this.whereSelected, ...whereSelectedSpecial]
    // Set the original where to be compare with the changes in
    // the state whereSelected
    this.whereSelectedCurrent = [...this.whereSelected]

    // DATE TIME DATA INIT
    this.startDate = this.itemSelected.startDateUnique
    this.startDateCurrent = this.itemSelected.startDateUnique
    this.startTime = this.itemSelected.startTimeUnique
    this.startTimeCurrent = this.itemSelected.startTimeUnique
    this.showEndTime = true

    // Use of terminatedAt when is different to null
    let terminatedAtDate = this.itemSelected.endDateUnique
    let terminatedAtTime = this.itemSelected.endTimeUnique
    if (this.itemSelected.terminatedAt) {
      const terminatedAtTemp = this.itemSelected.terminatedAt.split(' ')
      // console.log('terminatedAtTemp', terminatedAtTemp)
      terminatedAtDate = terminatedAtTemp[0]
      terminatedAtTime = terminatedAtTemp[1]
    }
    this.endDate = terminatedAtDate
    this.endDateCurrent = terminatedAtDate
    this.endTime = terminatedAtTime
    this.endTimeCurrent = terminatedAtTime

    // VEHICLES IN MISSION
    const idVehicles = []
    this.vehiclesInAMission.forEach(element => {
      idVehicles.push(element.id)
    })
    Object.assign(this.vehiclesAttached, this.vehiclesInAMission)
    this.vehiclesAttachedCurrent = idVehicles

    if (this.optionSelected === 2) this.getCurrentDateTime()
  }
}
</script>

<style lang="stylus" scoped>
#container-who-1::-webkit-scrollbar-track
{
  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
  background-color: #303030;
}

#container-who-1::-webkit-scrollbar
{
  width: 10px;
  background-color: #303030;
}

#container-who-1::-webkit-scrollbar-thumb
{
  border-radius: 10px;
  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #616161;
}

.container-search-result {
  background-color: #303030;
  border-radius: 2px;
  height: 100px;
  margin-top: -20px;
}

.container-vehicles-other-agency {
  background-color: #303030;
  border-radius: 2px;
  margin-top: -20px;
}

.list-who
  min-width 300px

.scroll-section
  background-color #303030
  border-radius 2px
  height 200px
  overflow auto

.info-vehicle-r
  background-color #616161
  height 40px
  margin-bottom 1px
  border-radius 2px

 .pointer-1
  cursor pointer

.pointer-1:hover
  opacity 0.7

.plate-border
  border 2px solid grey
  border-radius 5px

.bg-row-alt
  background-color rgba(255, 255, 255, 0.2)
  border-radius 2px
  padding-left 10px
  padding-right 10px

.bg-row
  background-color rgba(255, 255, 255, 0.1)
  border-radius 2px
  padding-left 10px
  padding-right 10px

.container-full-edition
  height calc(100vh - 200px)
  overflow-y auto

.name-selection
  color #424242

.description-selection
  color #616161

</style>



// WEBPACK FOOTER //
// src/components/Missions/ActionsMissions/ModifyMissionFullEdition.vue